import { render, staticRenderFns } from "./InstitucionPage.vue?vue&type=template&id=2156a8ac"
import script from "./InstitucionPage.js?vue&type=script&lang=js&external"
export * from "./InstitucionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports